export default __webpack_public_path__ + "static/media/invoice.c4d9b2cc.svg";